import { render, staticRenderFns } from "./QuestionDescription.vue?vue&type=template&id=0706f2d7"
import script from "./QuestionDescription.vue?vue&type=script&lang=js"
export * from "./QuestionDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports